(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"index_atlas_1", frames: [[1967,1050,53,75],[1162,1002,403,180],[1567,1050,231,46],[1746,1194,108,46],[1798,1098,151,46],[1567,1098,229,46],[1567,1002,245,46],[1800,1050,165,46],[1746,1146,225,46],[1491,1184,253,46],[1162,1184,327,46],[1814,1002,154,46],[1856,1194,107,46],[0,0,1920,1000],[0,1002,1160,187]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_89 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_88 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_87 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_86 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_85 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_84 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_83 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_82 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_81 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_80 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_79 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_78 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_77 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_76 = function() {
	this.initialize(img.CachedBmp_76);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2541,40);


(lib.imgCapaApp = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.linha = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.sign_out_text = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// SignOutText
	this.instance = new lib.CachedBmp_89();
	this.instance.setTransform(0,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.sign_out_text, new cjs.Rectangle(0,0,26.5,37.5), null);


(lib.sign_out_background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// SignOutBackground
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#990000").beginStroke().moveTo(-20,30).lineTo(-20,-30).lineTo(20,-30).lineTo(20,30).closePath();
	this.shape.setTransform(20,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.sign_out_background, new cjs.Rectangle(0,0,40,60), null);


(lib.pseudo_after = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// MenuPseudoAfter
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0.498)").beginStroke().moveTo(-68.6,25).lineTo(-68.6,-25).lineTo(68.6,-25).lineTo(68.6,25).closePath();
	this.shape.setTransform(68.6,25);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.pseudo_after, new cjs.Rectangle(0,0,137.2,50), null);


(lib.menu_background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["rgba(51,51,51,0)","#333333"],[0,1],-680.1,0,679.9,0).beginStroke().moveTo(-680,1).lineTo(-680,-1).lineTo(680,-1).lineTo(680,1).closePath();
	this.shape.setTransform(1240,-79);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// background
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-960,40).lineTo(-960,-40).lineTo(960,-40).lineTo(960,40).closePath();
	this.shape_1.setTransform(960,-40);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.menu_background, new cjs.Rectangle(0,-80,1920,80), null);


(lib.logo_small = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// logo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#000000").beginStroke().moveTo(65.4,45.3).curveTo(64.4,45,63.8,44.4).lineTo(64.3,43.4).curveTo(64.8,43.9,65.7,44.2).curveTo(66.6,44.5,67.5,44.5).curveTo(68.6,44.5,69.3,44.1).curveTo(69.8,43.7,69.8,43).curveTo(69.8,42.5,69.5,42.2).curveTo(69.2,41.9,68.7,41.7).lineTo(67.4,41.4).curveTo(66.3,41.1,65.7,40.8).curveTo(64.9,40.6,64.5,40).curveTo(64,39.5,64.1,38.6).curveTo(64.1,37.8,64.4,37.2).curveTo(64.9,36.6,65.7,36.2).curveTo(66.5,35.9,67.7,35.9).curveTo(68.5,35.9,69.4,36.1).curveTo(70.1,36.3,70.7,36.7).lineTo(70.3,37.8).curveTo(69.7,37.4,69,37.2).curveTo(68.4,37,67.7,37).curveTo(66.5,37,66,37.5).curveTo(65.3,37.9,65.3,38.5).curveTo(65.4,39,65.7,39.3).lineTo(66.5,39.8).lineTo(67.8,40.2).lineTo(69.6,40.7).curveTo(70.2,41,70.7,41.5).curveTo(71.2,42,71.2,42.9).curveTo(71.2,43.7,70.7,44.3).curveTo(70.4,44.9,69.5,45.3).curveTo(68.6,45.6,67.5,45.6).curveTo(66.4,45.6,65.4,45.3).closePath().moveTo(30.2,44.5).curveTo(29.2,43.5,29.2,41.4).lineTo(29.2,36).lineTo(30.6,36).lineTo(30.6,41.3).curveTo(30.6,44.4,33.3,44.4).curveTo(34.5,44.4,35.3,43.7).curveTo(35.9,42.9,36,41.3).lineTo(36,36).lineTo(37.2,36).lineTo(37.2,41.4).curveTo(37.2,43.5,36.2,44.6).curveTo(35.2,45.6,33.3,45.6).curveTo(31.3,45.6,30.2,44.5).closePath().moveTo(-30.8,45.3).curveTo(-31.8,45,-32.3,44.4).lineTo(-31.9,43.4).curveTo(-31.3,43.9,-30.4,44.2).curveTo(-29.6,44.5,-28.7,44.5).curveTo(-27.6,44.5,-26.9,44.1).curveTo(-26.4,43.7,-26.4,43).curveTo(-26.3,42.5,-26.7,42.2).curveTo(-27,41.9,-27.5,41.7).lineTo(-28.8,41.4).curveTo(-29.9,41.1,-30.5,40.8).curveTo(-31.2,40.6,-31.7,40).curveTo(-32.1,39.5,-32.1,38.6).curveTo(-32.1,37.8,-31.8,37.2).curveTo(-31.3,36.6,-30.5,36.2).curveTo(-29.7,35.9,-28.5,35.9).curveTo(-27.6,35.9,-26.8,36.1).curveTo(-26,36.3,-25.4,36.7).lineTo(-25.8,37.8).curveTo(-26.5,37.4,-27.2,37.2).curveTo(-27.8,37,-28.5,37).curveTo(-29.6,37,-30.2,37.5).curveTo(-30.8,37.9,-30.8,38.5).curveTo(-30.8,39,-30.5,39.3).curveTo(-30.2,39.7,-29.6,39.8).lineTo(-28.4,40.2).lineTo(-26.6,40.7).curveTo(-26,41,-25.5,41.5).curveTo(-25,42,-25,42.9).curveTo(-25,43.7,-25.5,44.3).curveTo(-25.8,44.9,-26.6,45.3).curveTo(-27.5,45.6,-28.7,45.6).curveTo(-29.8,45.6,-30.8,45.3).closePath().moveTo(-82.9,44.5).curveTo(-84,43.5,-84,41.4).lineTo(-84,36).lineTo(-82.6,36).lineTo(-82.6,41.3).curveTo(-82.6,44.4,-79.9,44.4).curveTo(-78.6,44.4,-77.9,43.7).curveTo(-77.2,42.9,-77.2,41.3).lineTo(-77.2,36).lineTo(-75.9,36).lineTo(-75.9,41.4).curveTo(-75.9,43.5,-77,44.6).curveTo(-78,45.6,-79.9,45.6).curveTo(-81.9,45.6,-82.9,44.5).closePath().moveTo(-95.8,45.3).curveTo(-96.8,45,-97.3,44.4).lineTo(-96.8,43.4).curveTo(-96.3,43.9,-95.4,44.2).curveTo(-94.5,44.5,-93.6,44.5).curveTo(-92.5,44.5,-91.9,44.1).curveTo(-91.3,43.7,-91.3,43).curveTo(-91.3,42.5,-91.6,42.2).curveTo(-91.9,41.9,-92.4,41.7).lineTo(-93.8,41.4).curveTo(-94.8,41.1,-95.5,40.8).curveTo(-96.1,40.6,-96.6,40).curveTo(-97.1,39.5,-97.1,38.6).curveTo(-97.1,37.8,-96.7,37.2).curveTo(-96.3,36.6,-95.4,36.2).curveTo(-94.7,35.9,-93.4,35.9).curveTo(-92.6,35.9,-91.7,36.1).curveTo(-91,36.3,-90.4,36.7).lineTo(-90.8,37.8).curveTo(-91.4,37.4,-92.1,37.2).curveTo(-92.8,37,-93.4,37).curveTo(-94.6,37,-95.1,37.5).curveTo(-95.8,37.9,-95.8,38.5).curveTo(-95.8,39,-95.4,39.3).curveTo(-95.1,39.7,-94.6,39.8).lineTo(-93.3,40.2).lineTo(-91.5,40.7).curveTo(-90.9,41,-90.5,41.5).curveTo(-90,42,-89.9,42.9).curveTo(-90,43.7,-90.4,44.3).curveTo(-90.8,44.9,-91.6,45.3).curveTo(-92.5,45.6,-93.6,45.6).curveTo(-94.7,45.6,-95.8,45.3).closePath().moveTo(95.8,45.5).lineTo(94.8,43.1).lineTo(89.7,43.1).lineTo(88.7,45.5).lineTo(87.3,45.5).lineTo(91.6,36).lineTo(93,36).lineTo(97.3,45.5).closePath().moveTo(90.2,42).lineTo(94.3,42).lineTo(92.3,37.4).closePath().moveTo(79,45.5).lineTo(79,37.2).lineTo(75.8,37.2).lineTo(75.8,36).lineTo(83.7,36).lineTo(83.7,37.2).lineTo(80.4,37.2).lineTo(80.4,45.5).closePath().moveTo(56.3,45.5).lineTo(56.3,36).lineTo(57.7,36).lineTo(57.7,45.5).closePath().moveTo(44.2,45.5).lineTo(44.2,36).lineTo(45.5,36).lineTo(45.5,44.3).lineTo(50.7,44.3).lineTo(50.7,45.5).closePath().moveTo(22.6,45.5).lineTo(21.5,43.1).lineTo(16.4,43.1).lineTo(15.4,45.5).lineTo(13.9,45.5).lineTo(18.3,36).lineTo(19.6,36).lineTo(23.9,45.5).closePath().moveTo(16.9,42).lineTo(21,42).lineTo(19,37.4).closePath().moveTo(2.1,45.5).lineTo(2.1,36).lineTo(5.8,36).curveTo(7.6,36,8.7,36.9).curveTo(9.8,37.8,9.7,39.3).curveTo(9.8,40.9,8.7,41.7).curveTo(7.6,42.6,5.8,42.6).lineTo(3.4,42.6).lineTo(3.4,45.5).closePath().moveTo(3.4,41.4).lineTo(5.8,41.4).curveTo(7,41.4,7.7,40.9).curveTo(8.4,40.4,8.4,39.3).curveTo(8.4,38.3,7.7,37.7).curveTo(7,37.2,5.8,37.2).lineTo(3.4,37.2).closePath().moveTo(-18.9,45.5).lineTo(-18.9,36).lineTo(-12.2,36).lineTo(-12.2,37.2).lineTo(-17.6,37.2).lineTo(-17.6,40.1).lineTo(-12.8,40.1).lineTo(-12.8,41.3).lineTo(-17.6,41.3).lineTo(-17.6,44.3).lineTo(-12,44.3).lineTo(-12,45.5).closePath().moveTo(-39.8,45.5).lineTo(-39.8,36).lineTo(-38.4,36).lineTo(-38.4,45.5).closePath().moveTo(-47.4,45.5).lineTo(-49.5,42.6).lineTo(-50.1,42.6).lineTo(-52.5,42.6).lineTo(-52.5,45.5).lineTo(-53.8,45.5).lineTo(-53.8,36).lineTo(-50.1,36).curveTo(-48.2,36,-47.2,36.9).curveTo(-46.2,37.8,-46.2,39.3).curveTo(-46.2,40.4,-46.6,41.2).curveTo(-47.2,42,-48.2,42.3).lineTo(-45.9,45.5).closePath().moveTo(-52.5,41.5).lineTo(-50.1,41.5).curveTo(-48.8,41.5,-48.2,40.9).curveTo(-47.5,40.3,-47.5,39.3).curveTo(-47.5,38.3,-48.2,37.7).curveTo(-48.8,37.2,-50.1,37.2).lineTo(-52.5,37.2).closePath().moveTo(-61.9,45.5).lineTo(-67.7,38.4).lineTo(-67.7,45.5).lineTo(-69,45.5).lineTo(-69,36).lineTo(-67.9,36).lineTo(-62.1,43.1).lineTo(-62.1,36).lineTo(-60.8,36).lineTo(-60.8,45.5).closePath().moveTo(-47.4,27.6).lineTo(-84.3,-19.7).lineTo(-84.3,26.7).lineTo(-96.8,26.7).lineTo(-96.8,-45.6).lineTo(-89.4,-45.6).lineTo(-52.4,1.8).lineTo(-52.4,-44.7).lineTo(-40,-44.7).lineTo(-40,27.6).closePath().moveTo(81,26.6).lineTo(50.6,-8.9).lineTo(81.3,-44.7).lineTo(96.6,-44.7).lineTo(65.9,-8.9).lineTo(96.3,26.6).closePath().moveTo(38.2,26.6).lineTo(38.2,-44.7).lineTo(50,-44.7).lineTo(50,26.6).closePath().moveTo(-6.6,26.6).lineTo(-6.6,-7.2).lineTo(5.3,-7.2).lineTo(5.3,26.6).closePath().moveTo(-6.6,-11).lineTo(-6.6,-44.7).lineTo(5.3,-44.7).lineTo(5.3,-11).closePath();
	this.shape.setTransform(97.3,45.625);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo_small, new cjs.Rectangle(0,0,194.6,91.3), null);


(lib.logo_large = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// logo
	this.instance = new lib.CachedBmp_88();
	this.instance.setTransform(0,0,0.4865,0.4865);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo_large, new cjs.Rectangle(0,0,196.1,87.6), null);


(lib.linha_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-357.9,108.8).lineTo(-357.9,-108.8).lineTo(357.9,-108.8).lineTo(357.9,108.8).closePath();
	mask.setTransform(357.925,108.8);

	// Camada_1
	this.instance = new lib.linha();
	this.instance.setTransform(0,0,0.6763,0.6763);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.linha_1, new cjs.Rectangle(0,0,715.9,126.5), null);


(lib.botoes = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-236.1,78).lineTo(-236.1,-78).lineTo(236.1,-78).lineTo(236.1,78).closePath();
	this.shape.setTransform(236.05,78.025);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(3).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,472.1,156.1);


(lib.arrow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#E1E1E2").beginStroke().moveTo(-24,12).lineTo(0,-12).lineTo(24,12).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-24,-12,48,24);


(lib.background_effect = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_40 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(40).call(this.frame_40).wait(1));

	// arc
	this.instance = new lib.linha_1();
	this.instance.setTransform(200.45,1063.1,1,1,0,0,0,392.2,63.2);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(41));

	// background
	this.instance_1 = new lib.imgCapaApp();

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(41));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-191.7,0,2111.7,1217.5);


(lib.arrow_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(9).call(this.frame_9).wait(1));

	// arrow
	this.instance = new lib.arrow("synched",0);
	this.instance.setTransform(0,12);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:-26},5).to({y:-12},2).to({x:0.3,y:-18.4},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-24,-38,48.3,62);


(lib.menu_marker = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {capa:0,institucional:1,localizacao:2,produto:3,setorizacao:4,diferenciais:5,implantacoes:6,orientacao:7,imagens:8,plantas:9,video:10};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(11));

	// arrow_up
	this.occ_arrow_up = new lib.arrow_up();
	this.occ_arrow_up.name = "occ_arrow_up";
	this.occ_arrow_up.setTransform(3.55,0);

	this.timeline.addTween(cjs.Tween.get(this.occ_arrow_up).wait(1).to({x:122.4},0).wait(1).to({x:271.75},0).wait(1).to({x:401.1},0).wait(1).to({x:531},0).wait(1).to({x:675.95},0).wait(1).to({x:826.3},0).wait(1).to({x:1002.15},0).wait(1).to({x:1153.4},0).wait(1).to({x:1260.7},0).wait(1).to({x:1356.3},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-20.4,0,1400.7,24);


// stage content:
(lib.index = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0];
	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		const AllTap = window.AllTap;
		
		/**
		 *
		 *  @param object
		 *  Set "this", object of canvas CreateJs.
		 */
		AllTap.setState({...AllTap.state, _this_index: this});
		
		/**
		 *
		 * @param array
		 *  [{
		 *      name: {string} = Name of occurrence not prefixed here "btn_".
		 *      occ_logo_large: {boolean} = Is visible (optional).
		 *      occ_logo_small: {boolean} = Is visible (optional).
		 *      occ_background_effect: {boolean} = Is visible (optional).
		 *      occ_video: {boolean} = Is button video, run outside the iFrame (optional).
		 *      occ_tour: {boolean} = Is button tour, run outside the iFrame (optional).
		 *      page_default: {boolean} = Define function $page_default() "root", finish of video (optional).
		 *  }]
		 */
		AllTap.createMenu([
		    {
		        name: 'capa',
		        occ_logo_large: false,
		        occ_logo_small: false,
		        occ_background_effect: true,
		        page_default: true
		    },
		    {
		        name: 'institucional',
		        occ_logo_large: true,
		        occ_logo_small: false,
		        occ_background_effect: false
		    },
		    {
		        name: 'localizacao',
		        occ_logo_large: true,
		        occ_logo_small: false,
		        occ_background_effect: false
		    },
		    {
		        name: 'produto',
		        occ_logo_large: true,
		        occ_logo_small: false,
		        occ_background_effect: false
		    },
		    {
		        name: 'setorizacao',
		        occ_logo_large: true,
		        occ_logo_small: false,
		        occ_background_effect: false
		    },
		    {
		        name: 'diferenciais',
		        occ_logo_large: true,
		        occ_logo_small: false,
		        occ_background_effect: false
		    },
		    {
		        name: 'implantacoes',
		        occ_logo_large: true,
		        occ_logo_small: false,
		        occ_background_effect: false
		    },
		    {
		        name: 'orientacao',
		        occ_logo_large: true,
		        occ_logo_small: false,
		        occ_background_effect: false
		    },
		    {
		        name: 'imagens',
		        occ_logo_large: false,
		        occ_logo_small: true,
		        occ_background_effect: false
		    },
		    {
		        name: 'plantas',
		        occ_logo_large: true,
		        occ_logo_small: false,
		        occ_background_effect: false
		    },
		    {
		        name: 'video',
		        occ_logo_large: true,
		        occ_logo_small: false,
		        occ_background_effect: false,
				occ_video: true
		    }
		]);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// BackgroundEffect
	this.occ_background_effect = new lib.background_effect();
	this.occ_background_effect.name = "occ_background_effect";
	this.occ_background_effect.setTransform(8.2,0.25);

	this.timeline.addTween(cjs.Tween.get(this.occ_background_effect).wait(1));

	// LogoLarge
	this.occ_logo_large = new lib.logo_large();
	this.occ_logo_large.name = "occ_logo_large";
	this.occ_logo_large.setTransform(87.45,978.15,1.0278,1.0274);
	this.occ_logo_large.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo_large).wait(1));

	// LogoSmall
	this.occ_logo_small = new lib.logo_small();
	this.occ_logo_small.name = "occ_logo_small";
	this.occ_logo_small.setTransform(117.45,992.2,0.7194,0.7189);
	this.occ_logo_small.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo_small).wait(1));

	// SignOutButton
	this.btn_sign_out = new lib.botoes();
	this.btn_sign_out.name = "btn_sign_out";
	this.btn_sign_out.setTransform(1870,1000,0.1059,0.5127);
	this.btn_sign_out.visible = false;
	new cjs.ButtonHelper(this.btn_sign_out, 0, 1, 2, false, new lib.botoes(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_sign_out).wait(1));

	// sign_out_text
	this.instance = new lib.sign_out_text();
	this.instance.setTransform(1900,1040,1,1,0,0,0,13.2,18.7);
	this.instance.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// sign_out_background
	this.instance_1 = new lib.sign_out_background();
	this.instance_1.setTransform(1900,1040,1,1,0,0,0,20,30);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// MenuPseudoAfter
	this.instance_2 = new lib.pseudo_after();
	this.instance_2.setTransform(674.8,1040,1,1,0,0,0,68.6,25);
	this.instance_2.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// MenuButton
	this.btn_setorizacao = new lib.botoes();
	this.btn_setorizacao.name = "btn_setorizacao";
	this.btn_setorizacao.setTransform(871.45,1010,0.2657,0.3844,0,0,0,0.6,0);
	new cjs.ButtonHelper(this.btn_setorizacao, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_video = new lib.botoes();
	this.btn_video.name = "btn_video";
	this.btn_video.setTransform(1727.45,1010,0.135,0.3844);
	new cjs.ButtonHelper(this.btn_video, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_capa = new lib.botoes();
	this.btn_capa.name = "btn_capa";
	this.btn_capa.setTransform(375,1010,0.1339,0.3844,0,0,0,0.4,0);
	new cjs.ButtonHelper(this.btn_capa, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_plantas = new lib.botoes();
	this.btn_plantas.name = "btn_plantas";
	this.btn_plantas.setTransform(1621,1010,0.1811,0.3844,0,0,0,0.3,0);
	new cjs.ButtonHelper(this.btn_plantas, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_localizacao = new lib.botoes();
	this.btn_localizacao.name = "btn_localizacao";
	this.btn_localizacao.setTransform(612.75,1010,0.2631,0.3846,0,0,0,0.4,0);
	new cjs.ButtonHelper(this.btn_localizacao, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_institucional = new lib.botoes();
	this.btn_institucional.name = "btn_institucional";
	this.btn_institucional.setTransform(459.2,1010,0.2805,0.3846);
	new cjs.ButtonHelper(this.btn_institucional, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_implantacoes = new lib.botoes();
	this.btn_implantacoes.name = "btn_implantacoes";
	this.btn_implantacoes.setTransform(1161.2,1010,0.2888,0.3846,0,0,0,0.1,0);
	new cjs.ButtonHelper(this.btn_implantacoes, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_imagens = new lib.botoes();
	this.btn_imagens.name = "btn_imagens";
	this.btn_imagens.setTransform(1513,1010,0.1845,0.3844,0,0,0,0.8,0);
	new cjs.ButtonHelper(this.btn_imagens, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_orientacao = new lib.botoes();
	this.btn_orientacao.name = "btn_orientacao";
	this.btn_orientacao.setTransform(1318.65,1010,0.3672,0.3844,0,0,0,0.4,0);
	new cjs.ButtonHelper(this.btn_orientacao, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_diferenciais = new lib.botoes();
	this.btn_diferenciais.name = "btn_diferenciais";
	this.btn_diferenciais.setTransform(1017.85,1010,0.2593,0.3844,0,0,0,0.4,0);
	new cjs.ButtonHelper(this.btn_diferenciais, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_produto = new lib.botoes();
	this.btn_produto.name = "btn_produto";
	this.btn_produto.setTransform(758,1010,0.1957,0.3844,0,0,0,0.5,0);
	new cjs.ButtonHelper(this.btn_produto, 0, 1, 2, false, new lib.botoes(), 3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.btn_produto},{t:this.btn_diferenciais},{t:this.btn_orientacao},{t:this.btn_imagens},{t:this.btn_implantacoes},{t:this.btn_institucional},{t:this.btn_localizacao},{t:this.btn_plantas},{t:this.btn_capa},{t:this.btn_video},{t:this.btn_setorizacao}]}).wait(1));

	// MenuText
	this.instance_3 = new lib.CachedBmp_87();
	this.instance_3.setTransform(876.35,1028.5,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_86();
	this.instance_4.setTransform(1732.45,1028.5,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_85();
	this.instance_5.setTransform(1625.95,1028.5,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_84();
	this.instance_6.setTransform(617.65,1028.5,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_83();
	this.instance_7.setTransform(464.25,1028.5,0.5,0.5);

	this.instance_8 = new lib.CachedBmp_82();
	this.instance_8.setTransform(762.95,1028.5,0.5,0.5);

	this.instance_9 = new lib.CachedBmp_81();
	this.instance_9.setTransform(1022.8,1028.5,0.5,0.5);

	this.instance_10 = new lib.CachedBmp_80();
	this.instance_10.setTransform(1166.2,1028.5,0.5,0.5);

	this.instance_11 = new lib.CachedBmp_79();
	this.instance_11.setTransform(1323.55,1028.5,0.5,0.5);

	this.instance_12 = new lib.CachedBmp_78();
	this.instance_12.setTransform(1517.9,1028.5,0.5,0.5);

	this.instance_13 = new lib.CachedBmp_77();
	this.instance_13.setTransform(379.95,1028.5,0.5,0.5);

	this.instance_14 = new lib.CachedBmp_76();
	this.instance_14.setTransform(447.75,1030,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	// MenuMarker
	this.occ_menu_marker = new lib.menu_marker();
	this.occ_menu_marker.name = "occ_menu_marker";
	this.occ_menu_marker.setTransform(402.95,1080);
	this.occ_menu_marker.shadow = new cjs.Shadow("rgba(0,0,0,1)",3,3,4);

	this.timeline.addTween(cjs.Tween.get(this.occ_menu_marker).wait(1));

	// MenuBackground
	this.occ_menu_background = new lib.menu_background();
	this.occ_menu_background.name = "occ_menu_background";
	this.occ_menu_background.setTransform(0,1080);

	this.timeline.addTween(cjs.Tween.get(this.occ_menu_background).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(776.5,540.3,1151.7,677.5);
// library properties:
lib.properties = {
	id: '5F0EC95E53C3814DAF2FA395200D5FE6',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"./images/CachedBmp_76.png?1692140071421", id:"CachedBmp_76"},
		{src:"./images/index_atlas_1.png?1692140071385", id:"index_atlas_1"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['5F0EC95E53C3814DAF2FA395200D5FE6'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
var createjs, AdobeAn;